// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';
import { getBrowserSupabaseKey } from './browserSupabaseKey';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;

// ENV-006I2: prefers REACT_APP_SUPABASE_PUBLISHABLE_KEY, falling back to the
// legacy REACT_APP_SUPABASE_ANON_KEY while production is still on legacy keys.
const supabasePublicKey = getBrowserSupabaseKey();


export const supabase = createClient(supabaseUrl, supabasePublicKey);
